import { z } from "zod"
import { CustomerType, productSchema } from "../../acquisitionForm/form/useAcquisitionFormSchema"
import { useSafeLocalStorage } from "../../../../../utils/localStorage"
import { useProductParam } from "../utils"

export const contractTypeFormSchema = z.object({
  product: productSchema,
  productionDataTariff: z.boolean(),
  measurementTypeConsent: z.boolean().default(false),
})

const householdContractTypeSchema = z.object({
  product: productSchema,
  productionDataTariff: z.boolean(),
  measurementTypeConsent: z.boolean().refine((value) => value, { message: "Musíte mít měření typu B." }),
})

export function getContractTypeFormSchema(customerType: CustomerType) {
  return customerType === "household" ? householdContractTypeSchema : contractTypeFormSchema
}

export type ContractTypeFormValues =
  | z.infer<typeof contractTypeFormSchema>
  | z.infer<typeof householdContractTypeSchema>

export function useStoredContractTypeFormValues(customerType: CustomerType) {
  const contractTypeSchema = getContractTypeFormSchema(customerType)
  return useSafeLocalStorage({
    // using different keys for different customer types because the schema is different
    //    and the useLocalStorage memoization reacts only to change of keys, therefore we need to align key changes to schema changes
    // https://github.com/streamich/react-use/blob/ade8d3905f544305515d010737b4ae604cc51024/src/useLocalStorage.ts#L82
    key: `acquisition-form-${customerType}-product`,
    schema: contractTypeSchema,
  })
}

export function useProductParamMatch(customerType: CustomerType) {
  const productParam = useProductParam()
  const [contractType] = useStoredContractTypeFormValues(customerType)

  return {
    product: contractType?.product,
    productParamMatch: contractType?.product === productParam,
  }
}
